export default __webpack_public_path__ + "static/media/recruit-acc2.4c69c883.svg";